import { StatementStatus } from '@/constants';
import { StatusInfoEntity } from '@/domains/StatusInfo';
import {
  AdditionalStatementStatus,
  AdditionalStatementType,
} from '@/constants';
import { isEnvAddDocumentsEnable } from '@/app.config';
import { AdditionalStatementEntity } from '@/domains';
import { StatementType } from '@/constants';

class StatusInfoService {
  hasAddDocumentsRejectedFolderAlt(
    additionalStatements: StatusInfoEntity['additionalStatements']
  ) {
    return additionalStatements.some(
      (addStatement) =>
        addStatement.type === AdditionalStatementType.ADD_DOCUMENTS &&
        addStatement.status === AdditionalStatementStatus.REJECTED_FOLDER_ALT
    );
  }

  getAddDocumentsDraft(
    additionalStatements: StatusInfoEntity['additionalStatements']
  ): AdditionalStatementEntity | undefined {
    return additionalStatements.find(
      (addStatement) =>
        addStatement.type === AdditionalStatementType.ADD_DOCUMENTS &&
        addStatement.status === AdditionalStatementStatus.DRAFT
    );
  }

  getResendToFsspDraft(
    additionalStatements: StatusInfoEntity['additionalStatements']
  ): AdditionalStatementEntity | undefined {
    return additionalStatements.find(
      (addStatement) =>
        addStatement.type === AdditionalStatementType.RESEND_TO_FSSP &&
        addStatement.status === AdditionalStatementStatus.DRAFT
    );
  }

  canAddDocuments({
    additionalStatements,
    statusCode,
    statementType,
  }: StatusInfoEntity) {
    return (
      isEnvAddDocumentsEnable[statementType] &&
      Boolean(this.getAddDocumentsDraft(additionalStatements)) &&
      [
        StatementStatus.IN_PROGRESS,
        StatementStatus.SUSPENDED_AWAITING_DOCUMENTS,
        StatementStatus.SUSPENDED_DOCUMENTS_PROVIDED,
        StatementStatus.AWAITING_PAYMENT,
        StatementStatus.QUITTANCE_PROVIDED,
      ].some((status) => status === statusCode)
    );
  }

  canResendToFssp({
    additionalStatements,
    statusCode,
    statementType,
  }: StatusInfoEntity) {
    const isNoticeRecovery = statementType === StatementType.NOTICE_RECOVERY;

    return (
      isNoticeRecovery &&
      Boolean(this.getResendToFsspDraft(additionalStatements)) &&
      [
        StatementStatus.FSSP_ISP_DOC_RECEIVED_FAILED,
        StatementStatus.FSSP_ISP_DOC_ACCEPTED_FAILED,
        StatementStatus.REJECTED_FROM_FSSP,
        StatementStatus.EDITED_FSSP_VALIDATION_ERROR,
      ].some((status) => status === statusCode)
    );
  }
}

export const statusInfoService = new StatusInfoService();
